import { IColumn } from '../../../core/components/Table'
import { sanitizeDate } from '../../../core/constants/times'

const ticketColumnSerial: IColumn[] = [
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'From Phone Number',
    accessor: 'fromPhone',
    sortable: true,
  },
  {
    title: 'To Phone Number',
    accessor: 'toPhone',
    sortable: true,
  },
  {
    title: 'At Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <>{sanitizeDate(row.createdAt)}</>,
  },
]

const ticketColumnBarcode: IColumn[] = [
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'From Phone Number',
    accessor: 'fromPhone',
    sortable: true,
  },
  {
    title: 'To Phone Number',
    accessor: 'toPhone',
    sortable: true,
  },
  {
    title: 'At Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <>{sanitizeDate(row.createdAt)}</>,
  },
]

const ticketColumnEmail: IColumn[] = [
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'From Phone Number',
    accessor: 'fromPhone',
    sortable: true,
  },
  {
    title: 'To Phone Number',
    accessor: 'toPhone',
    sortable: true,
  },
  {
    title: 'At Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <>{sanitizeDate(row.createdAt)}</>,
  },
]

const ticketColumnTopup: IColumn[] = [
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'From Phone Number',
    accessor: 'fromPhone',
    sortable: true,
  },
  {
    title: 'To Phone Number',
    accessor: 'toPhone',
    sortable: true,
  },
  {
    title: 'At Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <>{sanitizeDate(row.createdAt)}</>,
  },
]

export const getTransferHistoryColumn = (
  searchBy: 'serial' | 'barcode' | 'email' | 'topupOrder',
) => {
  switch (searchBy) {
    case 'serial':
      return ticketColumnSerial
    case 'barcode':
      return ticketColumnBarcode
    case 'email':
      return ticketColumnEmail
    case 'topupOrder':
      return ticketColumnTopup
    default:
      return ticketColumnSerial
  }
}
